// extracted by mini-css-extract-plugin
export default {"wrapper":"Container_wrapper__y43dn","content":"Container_content__2eBYQ"};